export default function ErrorDiv(props) {
  return (
    <div
      className="invalid-feedback"
      style={{
        borderRadius: "10px",
        fontSize: "12px",
        padding: "0.05rem 0.05rem",
        backgroundColor: "#f8d7da",
        color: "#721c24",
        borderColor: "#f5c6cb",
        display: "block",
        width: "100%",
        textAlign: "center",
        marginTop: "0.25rem",
      }}
    >
      {props.children}
    </div>
  );
}
